// src/belediye/components/mesajlasma/ConfirmDialog.js
// FAZ-38 — ortak onay modalı. ChatThread'deki (E1) "Sohbeti sil" öncesi zaten
// var olan `.msj-confirm` deseninden ÇIKARILDI: üye çıkarma (FAZ-B) ve görev
// tamamlama onayı (FAZ-38 §3.5) BURADAN geçer — davranış birebir korunur.
//
// FAZ-C: artık PORTAL YOK. Diyalog satır-içi çizilir; `.msj-confirm` position:
// absolute ile `.msj-thread` (sohbet alanı) içine gömülür (üye çekmecesi
// `.msj-members` ile aynı desen) → modal tüm ekranı ORTALAMAZ, sohbetin içinde
// açılır (kullanıcı isteği). Overlay tıklaması = vazgeç, panel tıklaması yayılmaz.

import React from "react";

export default function ConfirmDialog({
  open,
  title,
  text,
  confirmLabel = "Onayla",
  cancelLabel = "Vazgeç",
  confirmClassName = "msj-confirm-danger",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;
  return (
    <div className="msj-confirm" onClick={onCancel} role="dialog" aria-modal="true">
      <div className="msj-confirm-panel" onClick={(e) => e.stopPropagation()}>
        {title && <div className="msj-confirm-title">{title}</div>}
        <div className="msj-confirm-text">{text}</div>
        <div className="msj-confirm-actions">
          <button type="button" className="btn-md btn-md-ghost" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className={`btn-md ${confirmClassName}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
